module.exports = __webpack_public_path__ + "img/1_008.497a07ca.jpg";